import PropTypes from 'prop-types';
import React     from 'react';

import * as S                from './change-plan-qkn.module.scss';
import { PlanBoxQkn }        from './plan-box-qkn';
import { ModalWrapper }      from '../../modal-wrapper';
// import { ProductName }       from '../../../common/product/prod-name';
// import { ToggleSwitch }      from '../../../common/inputs/switch-field';
// import { TagLine }           from '../../../common/product/tag-line';
// import { Price }             from '../../../common/product/price';
import { useGlobalCtx }      from '../../../../context/ctx-hook';
import * as ProductSelectors from '../../../../context/selectors/product-selectors';
// import * as UserSelectors    from '../../../../context/selectors/user-selectors';
// import * as RouteHelpers     from '../../../../helpers/route-helper';
// import * as TimeHelpers      from '../../../../helpers/time-helpers';
import { getQknPriceWarn }   from '../../../../helpers/skunotices-helpers';
// import { Expiry }            from './../../../common/product/expiry';
// import { CancelDowngradeBox } from '../../../modals/change-plans/cancel-downgrade';
import { SingleProductRow }  from '../../../pages/subscriptions/unified-sub-tile/product-single-row';

const PRORATE_UPG_MSG = 'You will be charged a prorated amount based on the time remaining on your subscription.';
const PRORATE_DWNGRD_MSG = 'Your subscription will automatically renew to Classic Deluxe at the end of your current term.';

// function hasRecentUpgrade(orders = []) {
//   if (orders.length === 0) return false;

//   return orders
//     .filter(({action}) => action === 'UPGRADE')
//     .reduce((acm, {createdAt}) => acm ? acm : !TimeHelpers.is30DaysAfter(createdAt), false);
// }

const ChangePlanQkn = ({onClose, ctx: {product}}) => {
  const {state} = useGlobalCtx();

  // const [showMac, setShowMac] = React.useState(state.ui.isMac);
  // const HISTORY_LIST = UserSelectors.getUserSubHistory(state, product);
  const SUB = ProductSelectors.getSubscription(state, product);

  const {
    // autoRenew,
    active,
    expireOn,
    effectiveAt,
    // tierName,
    tierUriName,
    renewalTierUriName,
    renewalSku
  } = SUB;

  let PLANS = ProductSelectors.getChangePlanProductOfferings(product, state.country);

  const PLAN_INDEX          = PLANS.findIndex(({uriName}) => uriName === tierUriName);
  // const IS_30_AFTER_RENEWAL = TimeHelpers.is30DaysAfter(effectiveAt, 30);
  // const DISTANCE            = TimeHelpers.getDaysOut(expireOn);
  // const HAS_RECENT_UPGRADE  = hasRecentUpgrade(HISTORY_LIST);
  // const EXP_WITHIN_6_MONTHS = TimeHelpers.expWithin6MonthsOfToday(expireOn);
  // const PENDING_DOWNGRADE = renewalTierUriName ? renewalTierUriName !== tierUriName : false;

  const TIER_NOTICES = getQknPriceWarn(tierUriName, expireOn, state.country);
  let PRICE = '';

  if(state.country === 'us') {
    PRICE = (TIER_NOTICES?.HAS_PRICE_UPDATE)
      ? TIER_NOTICES.PRICE
      : ProductSelectors.getPriceBySku(state, renewalSku);
  }

  if(state.country === 'ca') {
    PRICE = (TIER_NOTICES?.HAS_PRICE_UPDATE)
      ? TIER_NOTICES.PRICE
      : ProductSelectors.getPriceBySku(state, renewalSku);
  }

  if (!active) {
    onClose();
  }

  return (
    <ModalWrapper heading="Change Plan" onClose={onClose}>
      <div className={S.qknCPWrapper} data-testid={'QKN_CHANGE_PLAN_CURRENT_PLAN'} >
        <div className={S.topContain}>
          <div className={S.label}>Your current plan</div>

          <div className={S.prodRowContain}>
            <SingleProductRow sub={SUB} isModal={true} showPrice={true} priceOverride={PRICE}/>
          </div>
        </div>

        <div>
          <div className={S.label}>Other Options</div>
          <div className={S.optionArea} data-testid={'QKN_CHANGE_PLAN_OPTIONS_BOXES'} >
            {PLANS.map(({uriName, sku, name}, i) => {
              if (uriName === tierUriName) return null;
              return (
                <PlanBoxQkn
                  key={sku}
                  name={name}
                  sku={sku}
                  priceOverride={TIER_NOTICES}
                  country={state.country}
                  currentTierUri={tierUriName}
                  renewalTierUriName={renewalTierUriName}
                  uriName={uriName}
                  action={PLAN_INDEX > i ? 'UPGRADE' : 'DOWNGRADE'}
                  boxText={PLAN_INDEX > i ? PRORATE_UPG_MSG : PRORATE_DWNGRD_MSG}
                  data-testid={'QKN_CHANGE_PLAN_PLAN_BOX'}
                  // hasRecentUpgrade={HAS_RECENT_UPGRADE}
                  // is30After={IS_30_AFTER_RENEWAL}
                  // daysOut={DISTANCE}
                />
              );
            })}
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};


ChangePlanQkn.displayName = 'ChangePlanQkn';
ChangePlanQkn.propTypes   = {
  onClose: PropTypes.func.isRequired,
  ctx:     PropTypes.shape({
    product: PropTypes.string.isRequired
  })
};

export { ChangePlanQkn };
